module.exports = __webpack_public_path__ + "img/popupAd-day1.65b3eca7.png";